import { Button as AntButton, ButtonProps, Col, Row } from 'antd';
import cn from 'classnames';
import React, { forwardRef } from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './Button.module.scss';
import 'antd/es/button/style/css';

type Props = {
  children?: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'info' | 'draft';
  color?: string;
  backgroundColor?: string;
  reversed?: boolean;
  layout?: string;
  height?: number | string;
  align?: 'bottom' | 'middle' | 'stretch' | 'top';
  gutter?: number;
  justify?: 'space-between' | 'space-around' | 'start' | 'end' | 'center';
  fullWidth?: boolean;
} & ButtonProps;

type Ref = HTMLButtonElement;

const Button = forwardRef<Ref, Props>(
  (
    {
      children,
      className,
      reversed,
      icon,
      align = 'middle',
      style = {},
      height,
      justify = 'center',
      layout,
      variant = 'default',
      color,
      backgroundColor,
      gutter = 8,
      fullWidth,
      ...props
    },
    ref,
  ) => {
    let classes = Styles['button'];

    if (layout === 'fixed') {
      classes += ' ant-btn-fixed';
    }

    if (icon) {
      classes += ' ant-btn-icon';
    }

    if (fullWidth) {
      classes += ' full-width';
    }

    if (icon && !children) {
      classes += ' ant-btn-icon-only';
    }

    if (variant) {
      classes += ` ant-btn-${variant}`;
    }

    if (color) {
      Object.assign(style, { color });
    }

    if (backgroundColor) {
      Object.assign(style, { backgroundColor });
    }

    return (
      <AntButton
        ref={ref}
        className={cn(classes, className)}
        style={{ height, ...style } as React.CSSProperties}
        {...props}
      >
        <Row
          gutter={gutter}
          align={align}
          justify={justify}
          style={{
            flexDirection: reversed && icon ? 'row-reverse' : undefined,
            height: '100%',
          }}
        >
          {icon && <Col>{icon}</Col>}
          {children ? <Col>{children}</Col> : null}
        </Row>
      </AntButton>
    );
  },
);

export default Button;
